import React, { useEffect, useState } from 'react'

const SearchBar = ({
  onSearchChange,
  placeholder = 'Search…',
  disabled = false,
  isSearching = false,
}) => {
  const [value, setValue] = useState('')

  useEffect(() => {
    if (disabled) {
      setValue('')
    }
  }, [disabled])

  const handleSearch = () => {
    if (disabled) return

    onSearchChange?.(value.trim())
  }

  const handleClear = () => {
    if (disabled) return

    setValue('')
    onSearchChange?.('')
  }

  return (
    <div className="input-group input-group-sm" style={{ maxWidth: 300, width: '100%' }}>
      <input
        type="text"
        className="form-control"
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        onChange={(e) => {
          if (disabled) return
          setValue(e.target.value)
        }}
        onKeyDown={(e) => {
          if (disabled) return

          if (e.key === 'Enter') handleSearch()
          if (e.key === 'Escape') handleClear()
        }}
        aria-label="Global search"
      />

      <button
        className="btn btn-primary"
        type="button"
        onClick={handleSearch}
        disabled={disabled || isSearching || !value.trim()}
        aria-label={isSearching ? 'Searching' : 'Search'}
      >
        {isSearching ? (
          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
        ) : (
          'Search'
        )}
      </button>

      <button
        className="btn btn-outline-secondary"
        type="button"
        onClick={handleClear}
        disabled={disabled || !value}
      >
        Clear
      </button>
    </div>
  )
}

export default SearchBar
